/**
 *
 * @module appAccount
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    number,
    string
} = Check.assert;

/**
 *
 * @class AppAccount
 *
 */
export default class AppAccount {

    /**
     *
     * @param {Number} [id=0]
     * @param {String} [name='']
     * @param {Number} [namespaceId=0]
     * @throws {InvalidArgumentException}
     * @note these are required params yet these values are not guaranteed to be in the config so we provide defaults
     *
     */
    constructor(id = 0, name = '', namespaceId = 0) {

        const errorMessage = {
            ctor: 'AppAccount(id, name, namespaceId)',
            id: () => {
                return `${this.ctor} id should be a Number`;
            },
            name: () => {
                return `${this.ctor} name should be a String`;
            },
            namespaceId: () => {
                return `${this.ctor} namespace should be a Number`;
            }
        };

        number(id, errorMessage.id, InvalidArgumentException);
        string(name, errorMessage.name, InvalidArgumentException);
        number(namespaceId, errorMessage.namespaceId, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.id = id;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.name = name;

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.namespaceId = namespaceId;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/appAccount.js